import { useCallback } from "react";
import { Tooltip } from "@/components";
import { LessonDto } from "@/types";
import ImgLessonDefault from "@/assets/default_img_lesson.png";
import MarkDoneImg from "@/assets/done.png";

export const LessonComponent = ({
  lesson,
  onLessonClick,
}: {
  lesson: LessonDto;
  onLessonClick: (lesson: LessonDto) => void;
}) => {
  const click = useCallback(() => {
    onLessonClick(lesson);
  }, [lesson, onLessonClick]);

  return (
    <div
      className="space-y-2 text-dark text-sm cursor-pointer group"
      onClick={click}
    >
      <div className="w-full aspect-video rounded-md bg-light_grey overflow-hidden">
        <img
          src={lesson?.image || ImgLessonDefault}
          alt={lesson?.title}
          className="w-full h-full object-fill group-hover:scale-[1.125] duration-300"
        />
      </div>
      <Tooltip content={lesson?.title} side="left">
        <div className="inline-flex justify-between w-full">
          <p className="w-full font-semibold leading-5.5 line-clamp-2 h-11 group-hover:text-cyan duration-200 whitespace-pre-wrap break-all">
            {lesson?.title}
          </p>
          {lesson.isDone && <img src={MarkDoneImg} className="h-6 w-6" />}
        </div>
      </Tooltip>
    </div>
  );
};

export const LessonPlaceholder = () => {
  return (
    <div className="space-y-2">
      <div className="w-full aspect-video rounded-md bg-light_grey"></div>
      <div className="h-11">
        <p className="w-full font-semibold leading-5.5 line-clamp-2 h-4 rounded-full bg-light_grey" />
      </div>
    </div>
  );
};
